<template lang="pug">
  #app
    //template(v-if="isMobile")
    //  vue-drawer-layout(ref="drawerLayout" :content-drawable="true")
    //    .drawer-content(slot="drawer")
    //      app-header
    //    .drawer-main-content(slot="content")
    //      a(href="javascript:void(0)" @click="handleToggleDrawer") ☰
    //      router-view(:key="$route.fullPath")
    //      app-footer
    //template(v-else)
    //  router-view(:key="$route.fullPath")

    router-view(:key="$route.fullPath")

</template>

<script>
  import platform from '@/libs/platform.js'

  export default {
    name: 'app',
    components: {
    },
    mounted () {

      if(platform.ismobile){
        this.$store.commit('setplatform')
      }else{
        window.addEventListener('scroll', this.watchScroll);
      }

      if(platform.isiphone){
        this.$store.commit('setiphone')
      }

      //获取导航数据
      this.$store.dispatch('setNavList')
    },
    methods: {
      handleToggleDrawer() {
        this.$refs.drawerLayout.toggle();
      },
      watchScroll() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        //  当滚动超过 50 时，实现吸顶效果
        // console.log(scrollTop);
        if (scrollTop > 1000) {
          //this.navBarFixed = true
          this.$store.commit('setBarFixed', true);
        } else {
          //this.navBarFixed = false
          this.$store.commit('setBarFixed', false);
        }
      }
    },
    computed: {
      isMobile () {
        return this.$store.state.isMobile
      }
    }
  }
</script>

<style lang="stylus">
  @import './assets/styles/global.styl'
</style>
